import request from '@/utils/request'
import qs from 'qs'
// 渠道获取自己名下的夹层码
export function getXcLayerCode(params) {
    return request({
        url: 'api/xcLayerCodeByChannel?' + qs.stringify(params, {
            indices: false
        }),
        method: 'get'
    })
}
// 新增
export function addXcLayerCode(data) {
    return request({
        url: 'api/xcLayerCode',
        method: 'post',
        data
    })
}
export function delXcLayerCode(id) {
    return request({
        url: 'api/xcLayerCode/' + id,
        method: 'delete'
    })
}

export function editXcLayerCode(data) {
    return request({
        url: 'api/xcLayerCode',
        method: 'put',
        data
    })
}

export function getXcLayerCodeFormId(id) {
    return request({
        url: 'cus/xcLayerCode/' + id,
        method: 'get',
    })
}
// 图片获取链接
export function getUrlByImg(data) {
    return request({
        url: 'api/layerCode/getUrlByImg',
        method: 'post',
        data
    })
}

// 获取夹层码图片 id
export function getXcLayerCodeImg(id) {
    return request({
        url: 'api/xcLayerCode/' + id,
        method: 'get',
    })
}

// 查询夹层码的已填写数据
export function getXcLayerData(params) {
    return request({
        url: 'api/xcLayerData?' + qs.stringify(params, {
            indices: false
        }),
        method: 'get'
    })
}


// WEBPACK FOOTER //
// ./src/api/layerCode.js